import styled from "styled-components";

export const Container = styled.div``;

export const Body = styled.div`
  margin: 15px 24px;
`;
